var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    style: _vm.hasChanged
      ? "background: rgba(0, 169, 157, 0.1); border: 1px solid rgba(0, 169, 157, 1);"
      : "",
    attrs: { id: _vm.id, readonly: _vm.readonly },
    domProps: { value: _vm.value },
    on: {
      focus: _vm.selectAll,
      input: function ($event) {
        return _vm.$emit("input", $event.target.value)
      },
      blur: function ($event) {
        return _vm.$emit("blur", $event.target.value)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }